
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 288h92.48l-32 160h128.624l34.576-172.8L224 64H0v224zM32 96h160v174.4L162.896 416H99.52l32-160H32V96zM288 64v224h92.48l-32 160h128.624l34.576-172.8L512 64H288zm192 206.4L450.896 416H387.52l32-160H320V96h160v174.4z"}})])
          )
        }
      }
    